// extracted by mini-css-extract-plugin
export default {"logIn":"LoginPage_logIn__WKAaF","logInButton":"LoginPage_logInButton__KK1xK"};